import { Box, IconButton } from '@mui/material'
import React, { useState } from 'react'
import Draggable from './Draggable'
import Element from './Element'
import AddIcon from '@mui/icons-material/Add'
import { getFirstKeyFromObject } from '../../utils/formBuilder'

import { draggableElementStyles } from '../../styles/classes/FormBuilderClasses'

export default function DraggableElement ({ item, onClickAdd, disabled }) {
  const { classes } = draggableElementStyles()
  const [show, setShow] = useState(false)
  const itemNameKey = item[getFirstKeyFromObject(item)].type
  return (
    <Box
      className={`${classes.container} ${show && classes.containerGray}`}
      onMouseOver={() => setShow(true)}
      onMouseOut={() => setShow(false)}
    >
      <Draggable id={getFirstKeyFromObject(item)} data={item}>
        <Element elementKey={itemNameKey} />
      </Draggable>
      {show && (
        <Box display="flex">
          <IconButton
            disabled={disabled}
            onClick={() => onClickAdd(item)}
            size="small"
            className={classes.iconButton}
          >
            <AddIcon className={classes.addIcon} />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}
